import { contains_subscription_plan, isMobile } from './common.js';
export default {
  init() {
    console.debug('product page');

    /**
     * How this works:
     * We'll override WC default post method to add items to the cart and hook ajax to avoid page reload.
     * A) If the product type has an active subscription plan, a modal with the two options (one time vs monthly subcription) will be displayed.
     * B) Otherwise the product will be added to the cart right away.
     * Both scenarios, will use ajax and trigger the side cart upon sucessful completion.
     *
     * Partly inspired by:
     * @source: //https://quadlayers.com/woocommerce-ajax-add-to-cart/
     */

    /* eslint-disable */

    /**
     * Init variables
     */
    let add_to_cart_button = $('.single_add_to_cart_button');
    let product_on = $('.product_add_on');
    let product_add_on = $('#product_add_on');
    let no_thanks_button = $('#no_thanks');
    let form = add_to_cart_button.closest('form.cart');
    let form_product_on = product_on.closest('form.cart');
    let discount = form.find('.wcsatt-sub-discount');
    let price = form.find('.controls .single-product.price');
    let first_run_customize_subscription_form = false;
    var first_run_define_product_type = false;
    var first_run_listen_product_type = false;
    let product_on_switch = $('#product_add_on').data('activate');
    let response_fragments = 0;
    let response_cart_hash = 0;
    let response_button = 0;
    var modal;
    var mainProductAjaxPromise = null; // Guardará la llamada AJAX principal
    define_product_type();
    listen_product_on_click();
    listen_not_thanks_click();
    listen_update_produnt_on();
    scrollProductHeader();
    /**
     * Get product type between one-time and hybrid (one-time AND subscription)
    */
    function define_product_type() {
      //On page load
      if (!first_run_define_product_type) {
        //Check if there is an active subcription for this product
        if (contains_subscription_plan(form)) {
          console.debug('on load: product contains a subscription');
          init_modal(add_to_cart_button, form);
        }
        else {
          console.debug('on load: product does not contain a subscription');
        }
        first_run_define_product_type = true;
        listen_product_click();
      }
    }
    /**
     * Listen for add to cart clicks
    */
    function listen_product_click() {
      console.debug('listening for add-to-cart click');
      $('.single_add_to_cart_button').on('click.listen_product_type', function listen_product_type(e) {
        e.preventDefault();
        e.stopPropagation();
        console.debug('[CLICK] first add to cart');
        //define_product_type(); //Commented this out bc instead of define (again?), let's process it. Having two separate functions should be less confusing
        process_product_type();
        first_run_listen_product_type = true;
      });
    }

    function listen_product_on_click() {
      $('.product_add_on').on('click.listen_product_type', function listen_product_type(e) {
        e.preventDefault();
        e.stopPropagation();
        console.debug('[CLICK] first add to cart');
        //define_product_type(); //Commented this out bc instead of define (again?), let's process it. Having two separate functions should be less confusing
        process_product_type_add_on();
        setProductPrincipal();
        first_run_listen_product_type = true;
      });
    }

    function listen_not_thanks_click() {
      $('#closeModal').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.debug('[CLICK] close modal');

        // 1. Cerramos el modal inmediatamente
        close_modal();

        // 2. Verificamos que la promesa AJAX exista
        if (mainProductAjaxPromise) {
          console.debug('Esperando que el AJAX del producto principal termine...');

          // 3. ¡ESPERAMOS! .done() se ejecutará solo DESPUÉS 
          //    de que el AJAX termine (después del 'success')
          mainProductAjaxPromise.done(function () {
            console.debug('AJAX terminado. Abriendo el carrito lateral.');

            // 4. AHORA SÍ abrimos el carrito, con los datos ya poblados
            $(document.body).trigger('added_to_cart', [response_fragments, response_cart_hash, response_button]);
            //tidioChatApi.track("added-product-cart");
            $('body').trigger('side_cart_open');
          });

        } else {
          console.error('Error: Se intentó cerrar el modal sin una promesa AJAX pendiente.');
        }
      });
    }

    function listen_close_modal_click() {
      $('#modaal-close').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.debug('[CLICK] close modal (X)');

        // 1. Cerramos el modal
        close_modal();

        // 2. Comentamos esto, es innecesario y conflictivo
        // force_set_buying_option('one-time'); 

        // 3. ¡ESPERAMOS!
        if (mainProductAjaxPromise) {
          console.debug('Esperando que el AJAX 1 (Principal) termine...');

          // .done() se ejecutará DESPUÉS de que el AJAX 1 termine
          mainProductAjaxPromise.done(function () {
            console.debug('AJAX 1 terminado. Abriendo carrito.');

            // 4. AHORA SÍ abrimos el carrito con los datos correctos
            $(document.body).trigger('added_to_cart', [response_fragments, response_cart_hash, response_button]);
            $('body').trigger('side_cart_open');
          });
        } else {
          console.error('Error: Se hizo clic en X pero el AJAX 1 no se encontró.');
        }
      });
    }

    function listen_update_produnt_on() {
      // Usamos '.off().on()' para evitar listeners duplicados
      $('#product_add_on').off('click.updatecart').on('click.updatecart', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.debug('[CLICK] update cart (YES! UPGRADE)');

        // ¡ESPERAMOS AL AJAX 1!
        if (mainProductAjaxPromise) {
          console.debug('AJAX 1 (Principal) existe. Esperando que termine...');

          // Esperamos que el producto 1 se añada
          mainProductAjaxPromise.done(function () {
            console.debug('AJAX 1 terminado. Lanzando AJAX 2 (Add-on)...');

            // Ahora que el producto 1 está en el carrito, llamamos a la
            // función que añade el producto 2 (el add-on).
            // setProductSecundary() se encargará de abrir el carrito
            // cuando el AJAX 2 termine.
            setProductSecundary();
          });
        } else {
          console.error('Error: Se hizo clic en YES! pero el AJAX 1 no se encontró.');
        }
      });
    }

    function scrollProductHeader() {
      if (isMobile) {
        window.addEventListener("load", (event) => {
          $('html, body').animate({
            scrollTop: $("#custom-events-demo").offset().top
          });
        });
      }
    }

    function setProductPrincipal() {
      let data = get_product_data(product_on, false);
      let buttons = product_on;
      mainProductAjaxPromise = ajax_add_to_cart(data, buttons);
    }

    function setProductSecundary() {
      let data = get_product_data(product_add_on, true);
      let buttons = product_add_on;
      ajax_add_to_cart_product_on(data, buttons);
    }

    /**
     * Trigger a modal when subscription, or directly add to cart when no subscription
    */
    function process_product_type() {
      //On click
      if (contains_subscription_plan(form)) {
        open_modal();
      } else {
        //add the product to the cart straight away
        let data = get_product_data(add_to_cart_button, false);
        ajax_add_to_cart(data, add_to_cart_button);
      }
    }

    /**
     * Trigger a modal when product on
    */
    function process_product_type_add_on() {
      //add the product to the cart straight away
      if (product_on_switch) {
        open_modal();
      } else {
        //add the product to the cart straight away
        let data = get_product_data(product_on, true);
        ajax_add_to_cart(data, product_on);
      }
    }

    /**
     * Initialize the subscription modal
     * @param {*} add_to_cart_button
     * @param {*} form
     */
    function init_modal() {
      let contador = 0;
      console.debug('[MODAL] init');
      //By hooking the modal to the body, we avoid the plugin adding
      //troublesome behaviors to the add to cart button
      modal = $('body').modaal({
        before_open: function () {
          form.fadeOut(400, function () {
            console.debug('hide the form');
          });

          console.debug('opening modal...');
        },
        after_open: function () {
          if (product_on_switch) {
            listen_close_modal_click();
            customize_productaddon_form(form_product_on);
            //force_set_buying_option('subscription');
            //get_buying_option_product_on(product_on, form_product_on);
            $('.modaal-content-container').addClass('product_add_on_modal');
          } else {
            customize_subscription_form(form);
            force_set_buying_option('subscription');
            get_buying_option(add_to_cart_button, form);
            //jQuery('.single_add_to_cart_button').('.Modaal'); //Remove click
          }
        },
        start_open: false,
        fullscreen: false,
        content_source: '.form-cart-wrapper',
        before_close: function () {
          console.debug('closing modaal...');
        },
        after_close: function () {
          //jQuery('.single_add_to_cart_button').modaal('destroy');
          //init_modal(add_to_cart_button, form);
          //jQuery('.single_add_to_cart_button').on('click.Modaal'); //Remove click
          if (product_on_switch) {
            $('.product_add_on').off('click#product_add_on');
            listen_product_on_click();
            product_on.show('slow');
            product_add_on.hide();
            $('.product-on-modal').remove();
          } else {
            $('.single_add_to_cart_button').off('click.add_to_cart_from_modal');
            force_set_buying_option('one-time');
            listen_product_click();
          }
        },
      });
    }

    /**
     * Open the subscription modal
     * @param object add_to_cart_button
     * @param object form
     */
    function open_modal() {
      if (modal == undefined) {
        init_modal();
      }
      modal.modaal('open');
      console.debug('[MODAL] open');

    }

    /**
     * Close the subscription modal
     */
    function close_modal() {
      if ($('#no_thanks').length > 0) {
        $('#no_thanks').hide();
      }
      modal.modaal('close');
    }

    /**
     * Customize the form.cart UI to suit our design
     * @param object form
     */
    function customize_subscription_form(form) {

      //Run these edits only ONCE to avoid duplicates on each click!
      if (!first_run_customize_subscription_form) {
        form.addClass('max-w-lg')
        form.find('.wcsatt-options-wrapper').prepend('<h3 class="text-4xl uppercase">Subscribe & Save</h3>');
        form.find('.subscription-price').prepend('<span class="subscription option-name">Monthly subscription</span>');
        discount.hide();
        form.find('.one-time-price').addClass('option-name').text('One time purchase');
        price.clone().appendTo('.one-time-option-details');
        form.find('.one-time-option-details').wrapInner('<div class="price"></div>');
        //form.find('.subscription.option-name').appendTo('<ul class="flex space-x-5 text-xs font-sans pl-0"><li>No hidden fees.</li><li>Free shipping.</li><li>Cancel anytime!</li></ul>');
        form.find('.subscription-price').contents().filter(function () {
          //Remove text NOT wrapped in a tag
          return (this.nodeType == 3);
        }).remove();
        form.find('.added_to_cart.wc-forward').remove();
        form.find(add_to_cart_button).removeClass('max-w-sm');
        form.find(no_thanks_button).toggle();
        form.on('click', selectOneTime);
        first_run_customize_subscription_form = true; //Edits have been applied. Don't do it again.
        console.debug('done editing form');
      }
      form.fadeIn(400, function () {
        console.debug('show the form');
      });
    }

    /**
     * Customize the form.cart UI to suit our design
     * @param object form
     */
    function customize_productaddon_form(form_product_on) {
      //Run these edits only ONCE to avoid duplicates on each click!
      if (product_on_switch) {
        product_on.hide();
        product_add_on.show('slow');
        form_product_on.addClass('max-w-lg');

        let price = (product_add_on.data('price-addon')) ? "<h5><span style='text-decoration: line-through;font-weight: 400;'>$" + product_add_on.data('price').toLocaleString("en-US", { maximumFractionDigits: 2 }) + "</span> $" + product_add_on.data('price-addon').toLocaleString("en-US", { maximumFractionDigits: 2 }) + " </h5>" : "<h5>" + "$" + product_add_on.data('price').toLocaleString("en-US", { maximumFractionDigits: 2 }) + "</h5>";
        $('.modaal-content-container').prepend('<div class="product-on-modal"></div>')
        $('.product-on-modal').prepend('<div class="image-container-on"></div>');
        $('.image-container-on').append('<h3>UPGRADE YOUR PURCHASE!</h3>');
        $('.image-container-on').append("<img src='" + product_add_on.data('image') + "' class='img-product-on' />");
        $('.image-container-on').append("<span>PERFECT PAIRING</span>");
        $('.product-on-modal').append("<h4> " + product_add_on.data('product-name') + " </h4>");
        $('.product-on-modal').append(price);
        //$('.product-on-modal').prepend('<span class="subscription option-name">Monthly subscription</span>');
        /*discount.hide();
        form_product_on.find('.one-time-price').addClass('option-name').text('One time purchase');
        price.clone().appendTo('.one-time-option-details');
        form_product_on.find('.one-time-option-details').wrapInner('<div class="price"></div>');
        //form_product_on.find('.subscription.option-name').appendTo('<ul class="flex space-x-5 text-xs font-sans pl-0"><li>No hidden fees.</li><li>Free shipping.</li><li>Cancel anytime!</li></ul>');
        */
        form_product_on.find('.subscription-price').contents().filter(function () {
          //Remove text NOT wrapped in a tag
          return (this.nodeType == 3);
        }).remove();
        form_product_on.find('.added_to_cart.wc-forward').remove();
        form_product_on.find(product_on).removeClass('max-w-sm');
        form_product_on.find(no_thanks_button).toggle();
        //form_product_on.on('click', selectOneTimeOnProduct);
        console.debug('done editing form');
      }
      form_product_on.fadeIn(400, function () {
        console.debug('show the form');
      });
    }

    /**
     * If the user choose to skip on the subscription
     */
    function selectOneTime(e) {
      if (e.target.id == 'no_thanks') {
        force_set_buying_option('one-time');
        setTimeout(function () {
          $('.single_add_to_cart_button').trigger('click');
        }, 100);
        e.preventDefault();

      }
    }

    /**
     * If the user choose to skip on the subscription
     */
    function selectOneTimeOnProduct(e) {
      if (e.target.id == 'closeModal') {
        force_set_buying_option('one-time');
        setTimeout(function () {
          $('.single_add_to_cart_button').trigger('click');
        }, 100);
        e.preventDefault();

      }
    }

    /**
     *  Process the chosen buying option (one-time or subscription plan)
     * @param boolean subscription_plan
     * @param object add_to_cart_button
     */
    function get_buying_option(add_to_cart_button, form) {

      console.debug('product has an active subscription');
      $('.single_add_to_cart_button').off('click.listen_product_type'); //Remove click

      let selected_option = form.find('input[type=radio]:checked').val();
      selected_option == 0 ? 'one-time' : 'subscription';
      console.debug('listening for buying option...');

      // Request add to cart from modal...
      $('.single_add_to_cart_button').on('click.add_to_cart_from_modal', function add_to_cart_from_modal(e) {
        console.debug(selected_option, 'buying option selected');
        e.preventDefault();
        e.stopPropagation();
        // $('.single_add_to_cart_button').off('click');
        $('.single_add_to_cart_button').off('click.add_to_cart_from_modal'); //Remove click
        let data = get_product_data(add_to_cart_button, false);
        ajax_add_to_cart(data, add_to_cart_button)
      });
    }

    /**
     *  Process the chosen buying option (one-time or subscription plan)
     * @param boolean subscription_plan
     * @param object add_to_cart_button
     */
    function get_buying_option_product_on(add_to_cart_button, form) {

      console.debug('product has an active subscription');
      $('.product_add_on').off('click.listen_product_type'); //Remove click

      let selected_option = form.find('input[type=radio]:checked').val();
      selected_option == 0 ? 'one-time' : 'subscription';
      console.debug('listening for buying option...');

      // Request add to cart from modal...
      $('.product_add_on').on('click#product_add_on', function add_to_cart_from_modal(e) {
        console.debug(selected_option, 'buying option selected');
        e.preventDefault();
        e.stopPropagation();
        // $('.product_add_on').off('click');
        $('.product_add_on').off('click#product_add_on'); //Remove click
        let data = get_product_data(add_to_cart_button, true);
        ajax_add_to_cart(data, add_to_cart_button)
      });
    }

    /**
     * Prepare product data to be sent to cart
     * @param object add_to_cart_button
     */
    /*function get_product_data(add_to_cart_button, product_add_on) {
      console.debug('getting product data...');

      //Prepare product attributes
      let $thisbutton = add_to_cart_button,
        $form = $thisbutton.closest('form.cart'),
        $product_type = $form.find('input[name*="convert_to_sub"]:checked'),
        product_subscription_period = $form.find('li.subscription-option input').val(),
        id = $thisbutton.val(),
        product_qty = $form.find('input[name=quantity]').val() || 1,
        product_id = $form.find('input[name=product_id]').val() || id,
        letiation_id = $form.find('input[name=letiation_id]').val() || 0,
        variation_id = $form.find('input[name=variation_id]').val() || add_to_cart_button.data('variation_id') || 0,
        price_no_kit = ($form.find('input[name=no-kit-price]').is(':checked')) ? $form.find('input[name=no-kit-price]').data('nokitprice') : false,
        price_add_on = (add_to_cart_button.data('price') != 0) ? add_to_cart_button.data('price') : false,
        //sku = $thisbutton.attr("data-product_sku") || 0,
        subscribe_to_action_input = typeof $product_type.val() == 'undefined' || $product_type.val() == '0' ? 'no' : 'yes',
        convert_to_sub_dropdown = 'convert_to_sub_dropdown' + id,
        convert_to_sub = 'convert_to_sub_' + id,
        convert_to_sub_val = $product_type.val();
      let data = {
        'action': 'ql_woocommerce_ajax_add_to_cart',
        'product_id': product_id,
        'product_sku': '',
        'quantity': product_qty,
        'letiation_id': letiation_id,
        'variation_id': variation_id,
        'subscribe-to-action-input': subscribe_to_action_input,
        // 'add-to-cart': product_id,
      };
      //Add properties that could not be added from variables using bracket notation ¯\_(ツ)_/¯
      if (price_no_kit) {
        data['price_no_kit'] = price_no_kit;
      }
      if (price_add_on) {
        data['price_add_on'] = price_add_on;
      }
      if (product_add_on) {
        data['product_add_on'] = product_add_on;
      }
      data[convert_to_sub_dropdown] = product_subscription_period;
      data[convert_to_sub] = convert_to_sub_val;

      //Add item to the cart
      return data;
      //ajax_add_to_cart(data, $thisbutton);
    }*/

    //Send the product to cart
    /*function ajax_add_to_cart(data, $thisbutton) {
      console.debug('start adding item via ajax');
      $.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        data: data,
        beforeSend: function () {
          console.table(data);
          $thisbutton.html('Adding...');
        },
        complete: function () {
          $thisbutton.html('Add to cart');
          $('#no-kit-price').prop('checked', false);
        },
        error: function (jqXHR, error, errorThrown) {
          if (jqXHR.status && jqXHR.status == 400) {
            console.error(jqXHR.responseText);
          } else {
            console.error(jqXHR.responseText);
            console.error(error);
            console.error(errorThrown);
          }
        },
        success: function (response) {
          console.debug(response);
          if (response.error & response.product_url) {
            console.error(response.error);
            window.location = response.product_url;
            return;
          } else {
            console.debug('finished. product ', data['product_id'], 'added to cart via ajax');
            //Close modal
            //tidioChatApi.track("added-product-cart");
            if (!product_on_switch) {
              $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
              if (modal !== undefined) {
                close_modal();
              }
              //Open the side-cart
              $('body').trigger('side_cart_open');
            } else {
              console.debug('dont open side cart');
              response_fragments = response.fragments;
              response_cart_hash = response.cart_hash;
              response_button = $thisbutton;
              //$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
              //$('body').trigger('side_cart_open');
            }
          }
        },
      });
    }*/

    /*function ajax_add_to_cart_product_on(data, $thisbutton) {
      console.debug('start adding item via ajax');
      // Se ejecuta 5 veces, con valores del paso 0 al 4.
      $.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        data: data,
        beforeSend: function () {
          console.table(data);
          $thisbutton.html('Adding...');
        },
        complete: function () {
          $thisbutton.html('YES! UPGRADE');
        },
        error: function (jqXHR, error, errorThrown) {
          if (jqXHR.status && jqXHR.status == 400) {
            console.error(jqXHR.responseText);
          } else {
            console.error(jqXHR.responseText);
            console.error(error);
            console.error(errorThrown);
          }
        },
        success: function (response) {
          console.debug(response);
          if (response.error & response.product_url) {
            console.error(response.error);
            window.location = response.product_url;
            return;
          } else {
            console.debug('finished. product ', data['product_id'], 'added to cart via ajax');
            $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
            //tidioChatApi.track("added-addon-product-cart");
            //Close modal
            if (modal !== undefined) {
              close_modal();
            }
            //Open the side-cart
            $('body').trigger('side_cart_open');
          }
        },
      });
      console.log('Camina un paso hacia el este');
    }*/


    //VARIATION RADIO BUTTONS SUPPORT
    $(document).on('change', '.variation-radios input', function () {
      $('.variation-radios input:checked').each(function (index, element) {
        var $el = $(element);
        var thisName = $el.attr('name');
        var thisVal = $el.attr('value');
        $('select[name="' + thisName + '"]').val(thisVal).trigger('change');
      });
    });
    $(document).on('woocommerce_update_variation_values', function () {
      $('.variation-radios input').each(function (index, element) {
        var $el = $(element);
        var thisName = $el.attr('name');
        var thisVal = $el.attr('value');
        $el.removeAttr('disabled');
        if ($('select[name="' + thisName + '"] option[value="' + thisVal + '"]').is(':disabled')) {
          $el.prop('disabled', true);
        }
      });
    });

    /**
     * Force form cart to an option (subscribe vs one-time)
     * @param string option: one-time || subscription
     */
    function force_set_buying_option(option) {
      $('form.cart li.' + option + '-option input').prop('checked', true);
      $('form.cart li.' + option + '-option input').trigger('change');
      console.debug('buying option force set to', option);
    }

    /* --------------------------- Gallery Slider --------------------------- */
    function buildProductGallerySliders() {
      let $productImageSlider = $('#product-images-carousel');
      let $productThumbnailSlider = $('.product-images-carousel-thumb');

      if ($productImageSlider.length) {

        $productImageSlider.on('init', function (slick) {
          //console.debug(slick);
          //If present, make the mobile .view-all slide the same height
          // var siblingColumn = $('.product-summary').height();
          // var $viewAllSlide = $productImageSlider.find('.view-all');
          // if ($viewAllSlide.length !== 0) {
          //   $viewAllSlide.height(siblingColumn);
          // }
        });

        $productImageSlider.slick({
          autoplay: false,
          speed: 500,
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          infinite: true,
          adaptiveHeight: false,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 1024,
              arrows: true
              // settings: 'unslick', //Destroy for desktop!
            },
          ],
        });

        if ($productThumbnailSlider.length) {
          $productThumbnailSlider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            vertical: true,
            asNavFor: '#product-images-carousel',
            arrows: false,
            dots: false,
            focusOnSelect: true,
            verticalSwiping: true,
          });
        }
      }
    }
    buildProductGallerySliders();
    function toggleDifferents() {
      $('.learn-differences').click(function () {
        if ($('.cards-difference').is(':visible')) {
          $('.cards-difference').css('display', 'none');
          $('.cards-difference').get(0).slick.setPosition();
          $('.cards-difference').slick('setPosition');
          $(this).find('.gg-chevron-up').addClass('gg-chevron-down').removeClass('gg-chevron-up');
        } else {
          $('.cards-difference').css('display', 'grid');
          $('.cards-difference').get(0).slick.setPosition();
          //$('.cards-difference').slick('setPosition').slickGoTo(2);
          $(this).find('.current-ham');
          $(this).find('.gg-chevron-down').addClass('gg-chevron-up').removeClass('gg-chevron-down');
          $('html,body').animate({
            scrollTop: $("#wholehams-single-product").offset().top
          },
            'slow');
        }
      });
    }
    toggleDifferents();

    function toggleDifferentsPrice() {
      $('#no-kit-price').change(function () {
        var price = $(this).data('price');
        var regularPrice = $(this).data('regulerprice');
        var is_onsale = $(this).data('isonsale');
        var nokitprice = $(this).data('nokitprice');
        if ($(this).prop('checked') == true) {
          price = price - nokitprice;
          if (is_onsale) {
            $(' .product-details .controls del .woocommerce-Price-amount').html('<bdi><span class="woocommerce-Price-currencySymbol">$</span>' + regularPrice + '.<sup class="price-decimal">00</sup></bdi>');
            $('.product-details .controls ins .woocommerce-Price-amount').html('<bdi><span class="woocommerce-Price-currencySymbol">$</span>' + price + '.<sup class="price-decimal">00</sup></bdi>');
          } else {
            $('.product-details .controls .woocommerce-Price-amount').html('<bdi><span class="woocommerce-Price-currencySymbol">$</span>' + price + '.<sup class="price-decimal">00</sup></bdi>');
          }

        } else {
          if (is_onsale) {
            $('.product-details .controls del .woocommerce-Price-amount').html('<bdi><span class="woocommerce-Price-currencySymbol">$</span>' + regularPrice + '.<sup class="price-decimal">00</sup></bdi>');
            $('.product-details .controls ins .woocommerce-Price-amount').html('<bdi><span class="woocommerce-Price-currencySymbol">$</span>' + price + '.<sup class="price-decimal">00</sup></bdi>');
          } else {
            $('.product-details .controls .woocommerce-Price-amount').html('<bdi><span class="woocommerce-Price-currencySymbol">$</span>' + price + '.<sup class="price-decimal">00</sup></bdi>');
          }

        }
      });
    }
    toggleDifferentsPrice();

    function gift_card_add_to_cart() {
      jQuery(document).ready(function ($) {

        // Usamos tu selector de formulario
        $("form.cart").on("submit", function (e) {
          e.preventDefault(); // Prevenir el envío

          var $this = $(this); // $this es el formulario
          var $button = $this.find('#btn-ajax-add-to-cart');
          var ajaxErrorContainer = $('#ajax-error-message');

          // --- PASO 1: Datos para AÑADIR AL CARRITO (AJAX 1) ---
          var cartData = {
            action: 'custom_add_gift_card_to_cart', // Endpoint 1
            product_id: $this.find('input[name="product_id"]').val(),
            variation_id: $this.find('input[name="variation_id"]').val(),
            quantity: 1,
            // ¡LA SEGURIDAD ES CLAVE AQUÍ!
            security: wc_add_to_cart_params.add_to_cart_nonce
          };

          // --- PASO 2: Datos PERSONALIZADOS para ACTUALIZAR (AJAX 2) ---
          var customData = {
            action: 'update_cart_item_with_gift_data', // ¡NUEVO ENDPOINT!

            // Los campos personalizados que queremos guardar
            you_email: $('#you_email').val(),
            recipient_email: $('#recipient_email').val(),
            personal_message: $('#personal_message').val(),
            you_name: $('#you_name').val(),
            recipient_name: $('#recipient_name').val(),

            // ¡LA SEGURIDAD TAMBIÉN ES CLAVE AQUÍ!
            security: wc_add_to_cart_params.add_to_cart_nonce
            // cart_item_key se añadirá después
          };


          // Iniciar estado de carga
          $button.addClass('loading').prop('disabled', true);
          if (ajaxErrorContainer) ajaxErrorContainer.slideUp();

          // --- LLAMADA AJAX 1: Añadir al Carrito ---
          console.log('AJAX 1: Enviando datos del carrito:', cartData);
          $.ajax({
            type: 'POST',
            url: wc_add_to_cart_params.ajax_url,
            data: cartData,
            success: function (cartResponse) {
              console.log('AJAX 1: Respuesta recibida:', cartResponse);

              // Si el producto se añadió Y nos devolvió la clave...
              if (cartResponse.success && cartResponse.data.cart_item_key) {

                // Añadimos la clave recibida a los datos personalizados
                customData.cart_item_key = cartResponse.data.cart_item_key;

                // --- LLAMADA AJAX 2: Actualizar el Ítem ---
                console.log('AJAX 2: Enviando datos personalizados:', customData);
                $.ajax({
                  type: 'POST',
                  url: wc_add_to_cart_params.ajax_url,
                  data: customData,
                  success: function (updateResponse) {
                    console.log('AJAX 2: Respuesta recibida:', updateResponse);

                    // Si la actualización fue exitosa Y nos dio la URL...
                    if (updateResponse.success && updateResponse.data.redirect_url) {
                      // ¡Éxito! Redirigimos al checkout
                      window.location.href = updateResponse.data.redirect_url;
                    } else {
                      // Error al actualizar
                      var msg = (updateResponse.data && updateResponse.data.message) ? updateResponse.data.message : 'Error updating cart item.';
                      if (ajaxErrorContainer) ajaxErrorContainer.text(msg).slideDown();
                      $button.removeClass('loading').prop('disabled', false);
                    }
                  },
                  error: function (xhr) {
                    console.error('AJAX 2 Error:', xhr.responseText);
                    if (ajaxErrorContainer) ajaxErrorContainer.text('Update AJAX error.').slideDown();
                    $button.removeClass('loading').prop('disabled', false);
                  }
                }); // Fin de AJAX 2

              } else {
                // Error al añadir al carrito (AJAX 1 falló)
                var msg = (cartResponse.data && cartResponse.data.message) ? cartResponse.data.message : 'Error adding product to cart.';
                if (ajaxErrorContainer) ajaxErrorContainer.text(msg).slideDown();
                $button.removeClass('loading').prop('disabled', false);
              }
            },
            error: function (xhr) {
              console.error('AJAX 1 Error:', xhr.responseText);
              if (ajaxErrorContainer) ajaxErrorContainer.text('Add to Cart AJAX error.').slideDown();
              $button.removeClass('loading').prop('disabled', false);
            }
          }); // Fin de AJAX 1
        });
      });
    }
    gift_card_add_to_cart();

    function multiple_add_to_cart() {
      $(document).ready(function () {

        // Añadimos un evento al botón de añadir al carrito
        $('.add_multiple_to_cart').on('click', function (e) {

          // Obtenemos los IDs y cantidades de los productos
          var product_ids = $(this).data('product_ids');
          var quantities = $(this).data('quantities');
          console.log(product_ids);
          console.log(quantities);
          // Enviamos una petición AJAX a la función de PHP
          $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'post',
            data: {
              action: 'woocommerce_ajax_add_multiple_products_to_cart',
              product_ids: product_ids,
              quantities: quantities
            },
            success: function (response) {
              $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $('.add_multiple_to_cart')]);
              // Actualizamos el carrito
              $('body').trigger('side_cart_open');
            }
          });

          e.preventDefault();
        });

      });
    }

    multiple_add_to_cart();

    function feedInstagram() {
      var feedinstagram = $('.product-instagram .feed-instagram');
      var settingsCompact = {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '60px',
        mobileFirst: true, //NEEDED FOR RESPONSIVE BREAKPOINTS TO WORK CORRECTLY
        centerMode: false,
        arrows: false,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 2000,
            settings: 'unslick',
          },
          {
            breakpoint: 2560,
            settings: 'unslick',
          },
          {
            breakpoint: 1440,
            settings: 'unslick',
          },
          {
            breakpoint: 1024,
            settings: 'unslick',
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      }
      feedinstagram.slick(settingsCompact);
    }

    function get_instagram_feed_ajax() {
      var sectionSeen = false;
      var product_id = ($(".product_add_on").val()) ? $(".product_add_on").val() : $(".single_add_to_cart_button").val();
      product_id = (product_id) ? product_id : $("#mc_stock_notify input[name='product_id']").val();
      var sectionInstagram = $("section.product-instagram");
      if (sectionInstagram.length > 0) {
        $(window).scroll(function () {
          var offset = sectionInstagram.offset().top;
          var windowTop = $(window).scrollTop();
          if (windowTop + $(window).height() - 20 >= offset && !sectionSeen) {
            sectionSeen = true; // Marcar la bandera como true para evitar futuras ejecuciones
            $.ajax({
              type: 'POST',
              dataType: 'html', // Assuming the server returns JSON
              url: "/wp-admin/admin-ajax.php",
              data: {
                action: "get_feed_instagram_ajax",
                product_id: product_id
              },
              success: function (data) {
                $('.product-instagram .feed-instagram').append(data); // Update element

                //buildBestSliders();
                feedInstagram();
              },
              error: function (jqXHR, textStatus, errorThrown) {
                console.error("AJAX Error:", textStatus, errorThrown); // Handle errors
              },
            });
            // La sección está a punto de entrar en la vista del usuario
            console.log("¡La sección está a punto de entrar en la vista del usuario!");
          }
        });
      }
    }

    get_instagram_feed_ajax();

    // --- Logic to open and close our modal ---

    const modalVideo = $('#video-modal');
    const iframeVideo = $('#youtube-iframe');
    const closeModalBtnVideo = $('#video-modal-close');

    // Function to open the modal
    function openModalVideo(videoUrl) {
      // Add autoplay to the YouTube URL
      const autoplayUrl = videoUrl + '?autoplay=1&rel=0&enable_js=1';
      iframeVideo.attr('src', autoplayUrl);
      modalVideo.addClass('visible');
    }

    // Function to close the modal
    function closeModalVideo() {
      modalVideo.removeClass('visible');
      // IMPORTANT: Stop the video on close so it doesn't keep playing
      iframeVideo.attr('src', '');
    }

    // --- Event handler for the video links ---

    // We use event delegation so it works with content loaded via AJAX.
    // We listen for clicks on a parent element that already exists on the page.
    $('body').on('click', '.lg-link', function (e) {
      e.preventDefault(); // Prevent the link from navigating to YouTube
      const videoUrl = $(this).attr('href');
      openModalVideo(videoUrl);
    });

    // Events to close the modal
    closeModalBtnVideo.on('click', closeModalVideo);
    modalVideo.on('click', function (e) {
      // Close the modal only if the dark background is clicked
      if ($(e.target).is(modalVideo)) {
        closeModalVideo();
      }
    });


    // --- Your AJAX function (now much simpler) ---

    function get_tapas_videos_ajax() {
      var sectionSeen = false;
      var product_id = ($(".product_add_on").val()) ? $(".product_add_on").val() : $(".single_add_to_cart_button").val();
      product_id = (product_id) ? product_id : $("#mc_stock_notify input[name='product_id']").val();
      var sectionInstagram = $("#tapas-videos");

      if (sectionInstagram.length > 0) {
        $(window).scroll(function () {
          var offset = sectionInstagram.offset().top;
          var windowTop = $(window).scrollTop();
          if (windowTop + $(window).height() - 20 >= offset && !sectionSeen) {
            sectionSeen = true;
            $.ajax({
              type: 'POST',
              dataType: 'html',
              url: "/wp-admin/admin-ajax.php",
              data: {
                action: "get_tapas_videos_ajax",
                product_id: product_id
              },
              success: function (data) {
                // 1. Add the HTML
                $('#tapas-videos').append(data);

                // 3. Run your slider
                // No more need to initialize LightGallery!
                buildPeekSliders();
              },
              error: function (jqXHR, textStatus, errorThrown) {
                console.error("AJAX Error:", textStatus, errorThrown);
              },
            });
          }
        });
      }
    }

    // Call your function
    get_tapas_videos_ajax();

    buildPeekProductSliders();
    function buildPeekSliders() {

      //Two visible items.
      var $peekSliderCompact = $('.slider.peek-slider-compact');
      if ($peekSliderCompact.length) {
        var settingsCompact = {
          dots: false,
          arrows: false,
          slidesToShow: 1,
          centerPadding: '32px',
          centerMode: false,
          mobileFirst: true, //NEEDED FOR RESPONSIVE BREAKPOINTS TO WORK CORRECTLY
          responsive: [
            {
              breakpoint: 1024,
              settings: 'unslick',
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        }
        $peekSliderCompact.slick(settingsCompact);
      }
    }

    function buildPeekProductSliders() {

      //Two visible items.
      var $peekSliderCompact = $('.products.products-list.slider.peek-slider');
      if ($peekSliderCompact.length) {
        var settingsCompact = {
          dots: false,
          arrows: false,
          slidesToShow: 1,
          mobileFirst: true, //NEEDED FOR RESPONSIVE BREAKPOINTS TO WORK CORRECTLY
          centerPadding: '32px',
          centerMode: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: 'unslick',
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        }
        $peekSliderCompact.slick(settingsCompact);
      }
    }

    /* * ========================================================================
 * MANEJADOR DE CLICS PRINCIPAL (LA SOLUCIÓN)
 * ========================================================================
 *
 * Este bloque reemplaza la lógica de .on() y .off() que estaba
 * dentro de 'get_buying_option_product_on'.
 * Se añade una sola vez cuando la página carga y maneja todos los
 * clics en '.product_add_on' de forma segura.
 */


    /**
     * Process the chosen buying option (one-time or subscription plan)
     * @param boolean subscription_plan
     * @param object add_to_cart_button
     */
    function get_buying_option_product_on(add_to_cart_button, form) {

      console.debug('product has an active subscription');

      // Removemos el listener antiguo (si existe)
      jQuery('.product_add_on').off('click.listen_product_type');

      // ¡YA NO SE AÑADEN LISTENERS AQUÍ!
      // El manejador delegado de arriba se encarga de esto.

      // Esta línea no hacía nada, la comentamos o eliminamos.
      // let selected_option = form.find('input[type=radio]:checked').val();
      // selected_option == 0 ? 'one-time' : 'subscription';

      console.debug('listening for buying option... (manejador delegado está activo)');
    }

    /**
     * Prepare product data to be sent to cart
     * @param object add_to_cart_button
     */
    function get_product_data(add_to_cart_button, product_add_on) {
      console.debug('getting product data...');

      // Usamos 'jQuery' por compatibilidad
      var $thisbutton = add_to_cart_button,
        $form = $thisbutton.closest('form.cart'),
        $product_type = $form.find('input[name*="convert_to_sub"]:checked'),
        product_subscription_period = $form.find('li.subscription-option input').val(),
        id = $thisbutton.val(),
        product_qty = $form.find('input[name=quantity]').val() || 1,
        product_id = $form.find('input[name=product_id]').val() || id,

        // --- CORRECCIÓN DE ERROR TIPOGRÁFICO ---
        // Combinamos las dos líneas y eliminamos 'letiation_id'
        variation_id = $form.find('input[name=variation_id]').val() || add_to_cart_button.data('variation_id') || 0,

        price_no_kit = ($form.find('input[name=no-kit-price]').is(':checked')) ? $form.find('input[name=no-kit-price]').data('nokitprice') : false,
        price_add_on = (add_to_cart_button.data('price') != 0) ? add_to_cart_button.data('price') : false,
        subscribe_to_action_input = typeof $product_type.val() == 'undefined' || $product_type.val() == '0' ? 'no' : 'yes',
        convert_to_sub_dropdown = 'convert_to_sub_dropdown' + id,
        convert_to_sub = 'convert_to_sub_' + id,
        convert_to_sub_val = $product_type.val();

      var data = {
        'action': 'ql_woocommerce_ajax_add_to_cart',
        'product_id': product_id,
        'product_sku': '',
        'quantity': product_qty,
        'variation_id': variation_id, // Usamos la variable corregida
        'subscribe-to-action-input': subscribe_to_action_input,
      };

      //Add properties that could not be added from variables
      if (price_no_kit) {
        data['price_no_kit'] = price_no_kit;
      }
      if (price_add_on) {
        data['price_add_on'] = price_add_on;
      }
      if (product_add_on) {
        data['product_add_on'] = product_add_on;
      }
      data[convert_to_sub_dropdown] = product_subscription_period;
      data[convert_to_sub] = convert_to_sub_val;

      //Add item to the cart
      return data;
    }

    //Send the product to cart
    function ajax_add_to_cart(data, $thisbutton) {
      console.debug('start adding item via ajax');

      // Usamos 'jQuery' por compatibilidad
      return jQuery.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        data: data,
        beforeSend: function () {
          console.table(data);
          $thisbutton.html('Adding...');
        },
        complete: function () {
          $thisbutton.html('Add to cart');
          jQuery('#no-kit-price').prop('checked', false);
        },
        error: function (jqXHR, error, errorThrown) {
          if (jqXHR.status && jqXHR.status == 400) {
            console.error(jqXHR.responseText);
          } else {
            console.error(jqXHR.responseText);
            console.error(error);
            console.error(errorThrown);
          }
        },
        success: function (response) {
          console.debug(response);

          if (response.error & response.product_url) {
            console.error(response.error);
            window.location = response.product_url;
            return;
          } else {
            console.debug('finished. product ', data['product_id'], 'added to cart via ajax');
            //Close modal
            //tidioChatApi.track("added-product-cart");
            //jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

            // Esta lógica parece depender de variables globales (product_on_switch, modal)
            // Asegúrate de que estén definidas en tu script.
            if (!$thisbutton.hasClass('product_add_on')) {
              // --- INICIO DE CORRECCIÓN ---

              // *** ESCENARIO A: NO ES UN ADD-ON ***
              // El trigger y el side_cart_open van JUNTOS aquí.

              // 1. Actualiza el carrito

              jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

              // 3. Abre el carrito
              jQuery('body').trigger('side_cart_open');
            } else {
              //jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
              console.debug('dont open side cart');

              // Estas variables no se usan, pero las dejamos por si tu código las necesita
              response_fragments = response.fragments;
              response_cart_hash = response.cart_hash;
              response_button = $thisbutton;
            }
          }
        },
      });
    }

    // Esta función es llamada en tu código original, así que la incluimos.
    // NOTA: El manejador delegado de arriba llama a 'ajax_add_to_cart', no a esta.
    // Si necesitas que se llame a esta, debes modificar el manejador delegado.
    function ajax_add_to_cart_product_on(data, $thisbutton) {
      console.debug('start adding item via ajax');
      // Se ejecuta 5 veces, con valores del paso 0 al 4. (Este comentario es el síntoma del problema original)

      jQuery.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        data: data,
        beforeSend: function () {
          console.table(data);
          if ($($thisbutton).find("#loading").length === 0) {
            // Si no existe, agregar el elemento a la lista
            $($thisbutton).append("<span id='loading'></span>");
          }
        },
        complete: function () {
          $("span#loading").remove();
          $thisbutton.html('YES! UPGRADE');
        },
        error: function (jqXHR, error, errorThrown) {
          if (jqXHR.status && jqXHR.status == 400) {
            console.error(jqXHR.responseText);
          } else {
            console.error(jqXHR.responseText);
            console.error(error);
            console.error(errorThrown);
          }
        },
        success: function (response) {
          console.debug(response);
          if (response.error & response.product_url) {
            console.error(response.error);
            window.location = response.product_url;
            return;
          } else {
            console.debug('finished. product ', data['product_id'], 'added to cart via ajax');
            jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
            //tidioChatApi.track("added-addon-product-cart");

            //Close modal
            if (typeof modal !== 'undefined' && modal !== null) {
              close_modal();
            }
            //Open the side-cart
            //updateMiniCartQuantity();
            jQuery('body').trigger('side_cart_open');
          }
        },
      });
      console.log('Camina un paso hacia el este'); // Este console.log parece de depuración, puedes quitarlo
    }

    var updateTimeout;

    jQuery(document).on('change input', '.woocommerce-mini-cart .qty', function (e) {
      var $input = jQuery(this);
      var $cartItem = $input.closest('.woocommerce-mini-cart-item');
      var qty = $input.val();

      // Obtener la 'key' del producto (compatible con varios formatos de name)
      var nameAttr = $input.attr('name');
      var match = nameAttr && nameAttr.match(/cart\[(.*?)\]\[qty\]/);
      var cart_item_key = match ? match[1] : ($input.data('cart_item_key') || $cartItem.data('cart_item_key'));

      if (!cart_item_key) return;

      // Reiniciar temporizador (Debounce)
      if (updateTimeout !== undefined) {
        clearTimeout(updateTimeout);
      }

      // UI OPTIMISTA: Feedback visual inmediato (solo en el item)
      $cartItem.css('opacity', '0.5');
      $input.addClass('loading');

      // Esperar 500ms a que el usuario termine de escribir
      updateTimeout = setTimeout(function () {
        jQuery.ajax({
          type: 'POST',
          url: wc_add_to_cart_params.ajax_url,
          data: {
            action: 'my_update_cart_qty',
            cart_item_key: cart_item_key,
            qty: qty
          },
          success: function (response) {
            if (response.fragments) {

              // --- AQUÍ ESTÁ LA MAGIA ---
              // Recorremos los fragmentos recibidos (Carrito + Cross Sells)
              // y los reemplazamos en el HTML a la fuerza.
              jQuery.each(response.fragments, function (selector, html) {
                jQuery(selector).replaceWith(html);
              });

              // Disparadores extra para compatibilidad con temas/plugins
              jQuery(document.body).trigger('wc_fragments_refreshed');
              jQuery(document.body).trigger('updated_wc_div');
            }
          },
          error: function () {
            console.error('Error al actualizar cantidad');
            // Revertir opacidad si falla
            $cartItem.css('opacity', '1');
          },
          complete: function () {
            // Limpieza final de estilos de carga
            jQuery('.woocommerce-mini-cart-item').css('opacity', '1');
            jQuery('.woocommerce-mini-cart .qty').removeClass('loading');
          }
        });
      }, 500);
    });
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/single-product.js